import React from 'react';
import PropTypes from 'prop-types';

const SuperuserMsg = ({ isSuperuser, customerLogin }) => (isSuperuser && (
  <div className="sum-wrapper">
    <div className="sum-message">
      You are logged in as super user for customer login: <strong>{customerLogin}</strong>.
      Click <a href="/webshop/logout.do" className="sum-logoutLink">here</a> to return to Aloe.
    </div>
  </div>
));

SuperuserMsg.propTypes = {
  isSuperuser: PropTypes.bool.isRequired,
  customerLogin: PropTypes.string,
};

export default SuperuserMsg;
